import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { TranslateModule } from "@ngx-translate/core";

import { MatChipsModule } from "@angular/material/chips";

import { ChipListComponent } from "./chip-list.component";

@NgModule({
  imports: [CommonModule, TranslateModule, MatChipsModule],
  declarations: [ChipListComponent],
  exports: [ChipListComponent],
})
export class ChipListModule {}
